module.exports = __webpack_public_path__ + "img/ese-logo-text.c2adb061.png";